module.exports = __webpack_public_path__ + "img/2026-08_experiential-learning.1e9b3ff2.webp";